var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176 466 c-52 -19 -86 -45 -114 -86 -116 -171 39 -398 240 -350 74 18 150 94 168 168 23 96 -20 198 -104 247 -56 33 -135 41 -190 21z m138 -18 c23 -7 59 -30 82 -54 129 -128 36 -350 -146 -348 -184 1 -277 212 -152 346 58 61 133 81 216 56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 305 l-55 -55 57 -57 c32 -31 61 -54 65 -50 4 4 -15 30 -42 57 l-49 50 47 48 c26 26 47 51 47 55 0 17 -19 4 -70 -48z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.05d2cff6d7a4a3ff848feb5b5c10e124.svg";
export { ForwardRef as ReactComponent };